import { render, staticRenderFns } from "./last-dialogs.vue?vue&type=template&id=2a263bb6&scoped=true&"
import script from "./last-dialogs.vue?vue&type=script&lang=js&"
export * from "./last-dialogs.vue?vue&type=script&lang=js&"
import style0 from "./last-dialogs.vue?vue&type=style&index=0&id=2a263bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a263bb6",
  null
  
)

export default component.exports